import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/lianai', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const navBg = scrolled || !isHome
    ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
    : 'bg-transparent';

  const textColor = scrolled || !isHome
    ? 'text-foreground-900'
    : 'text-white';

  const logoColor = scrolled || !isHome
    ? 'text-primary-500'
    : 'text-white';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`font-heading text-2xl whitespace-nowrap cursor-pointer transition-colors duration-300 ${logoColor}`}>
            yy漫画网
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 hover:opacity-80 ${textColor}`}
              >
                {link.label}
              </Link>
            ))}
            <div className={`relative ${textColor}`}>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm w-48 focus:w-64 transition-all duration-300 outline-none border ${
                  scrolled || !isHome
                    ? 'bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400'
                    : 'bg-white/20 border-white/30 text-white placeholder-white/60'
                }`}
              />
              <i className={`ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm ${textColor}`} />
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-foreground-900 py-2 cursor-pointer hover:text-primary-500 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <div className="relative pt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 rounded-full text-sm w-full outline-none border bg-background-100 border-background-200 text-foreground-900 placeholder-foreground-400"
              />
              <i className="ri-search-line absolute left-3 top-[18px] text-sm text-foreground-400" />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}